export const ERROR_PAGE_PROPS = {
  message: {
    type: String,
    default: null,
  },
} as const
